const projects = [
  {
    title: "Kanbas",

    description:
      "A robust Learning Management System (LMS) inspired by Canvas, designed to streamline the management of courses, assignments, grades, and modules in an educational setting. ",

    image: "kanbas",

    link: "https://github.com/damyantjain/kanbas-react-web-app",
  },

  {
    title: "Jiffy",

    description:
      "A comprehensive food delivery application built with React.js, Redux, and TailwindCSS . Integrates live APIs from Swiggy offering real-time ordering experience.",

    image: "jiffy",

    link: "https://github.com/damyantjain/jiffy",
  },

  {
    title: "Admitly",

    description:
      "A unified admission portal for rapid admission process for both students and universities. Powered by Spring Boot and deployed on Azure Web Apps",

    image: "admitly",

    link: "https://github.com/gauravtejwani24/UniversityApplicationPortal",
  },

  {
    title: "Customer Manager",

    description:
      "A powerful WPF-based client for managing customer data, leveraging gRPC services for high performance and scalability utilizing streaming and asynchronous communication.",

    image: "customerManagement",

    link: "https://github.com/damyantjain/WPF-Customer-App",
  },
  {
    title: "useFormAutoSave",
    description:
      "A lightweight, customizable React hook that automatically saves form data to prevent loss during user sessions. Provides configurable save intervals, state persistence, and seamless integration with form libraries.",
    image: "useFormAutoSave",
    link: "https://github.com/damyantjain/use-form-auto-save",
  },
  {
    title: "Portfolio Website",
    description:
      "A responsive personal portfolio built with React, Tailwind CSS, and Framer Motion. Features interactive animations, dark mode support, and a clean, modern design to showcase my projects and skills.",
    image: "portfolio",
    link: "https://github.com/damyantjain/portfolio-website",
  },
  {
    title: "CoralCake",
    description:
      "A benchmarking platform for Large Language Models (LLMs). Run a single prompt across multiple LLMs (OpenAI, Mistral, etc.) and compare latency, token usage, and cost in real time. Export results as CSV/JSON and review historical runs side-by-side to pick the best model for your use case.",
    image: "coralcake",
    link: "https://github.com/damyantjain/CoralCake",
    demo: "https://coralcake.vercel.app",
  },
  {
    title: "NeatMeet",
    description:
      "A community event discovery app that allows users to explore events happening around them, filter events by location, search for events, and interact with the event community through voting and creating events.",
    image: "neatmeet",
    link: "https://github.com/damyantjain/NeatMeet",
  }
];

export default projects;
